import AdminDashboard from "../pages/Admin/Dashboard/AdminDashboard";

import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import Profile from "../pages/Admin/Profile/Profile";
import Banner from "../pages/Admin/Banners/Banner";
import BannerCreate from "../pages/Admin/Banners/BannerCreate/BannerCreate";
import LotteryBrands from "../pages/Admin/LotteryBrands/ViewLotteryBrands/LotteryBrands";
import CreateLotteryBrands from "../pages/Admin/LotteryBrands/CreateLotteryBrands/CreateLotteryBrands";
import EditLotteryBrands from "../pages/Admin/LotteryBrands/EditLotteryBrands/EditLotteryBrands";
import LotteryBrandDays from "../pages/Admin/LotteryBrandDays/LotteryBrandDays";
import LotteryBrandDaysCreate from "../pages/Admin/LotteryBrandDays/LotteryBrandDaysCreate/LotteryBrandDaysCreate";
import EditLotteryBrandDays from "../pages/Admin/LotteryBrandDays/LotteryBrandDaysEdit/LotteryBrandDaysEdit";
import BulkRegistration from "../pages/Admin/BulkRegistration/BulkRegistration";
import BulkResult from "../pages/Admin/BulkResult/BulkResult";
import RemainingTickets from "../pages/Admin/RemainingTickets/RemainingTickets";
import LotteryListing from "../pages/Admin/LotteryListing/LotteryListing";
import ViewTickets from "../pages/Admin/LotteryListing/ViewTickets/ViewTickets";
import WinnersList from "../pages/Admin/WinnersList/WinnersList";
import Inquiries from "../pages/Admin/Inquiries/Inquiries";
import ViewInquiry from "../pages/Admin/Inquiries/ViewInquiry/ViewInquiry";
import Payments from "../pages/Admin/Payments/Payments";
import TicketReports from "../pages/Admin/TicketReports/TicketReports";
import Users from "../pages/Admin/Users/Users";
import Staff from "../pages/Admin/Staff/Staff";
import Masm from "../pages/Admin/LotteryListing/Results/Masm/Masm";
import Hadahana from "../pages/Admin/LotteryListing/Results/Hadahana/Hadahana";
import Adsa from "../pages/Admin/LotteryListing/Results/Adsa/Adsa";
import Dhni from "../pages/Admin/LotteryListing/Results/Dhni/Dhni";
import Mepo from "../pages/Admin/LotteryListing/Results/Mepo/Mepo";
import Govi from "../pages/Admin/LotteryListing/Results/Govi/Govi";
import Jaya from "../pages/Admin/LotteryListing/Results/Jaya/Jaya";
import WithdrawalRequests from "../pages/Admin/WithdrawalRequests/WithdrawalRequests";
import ViewRequest from "../pages/Admin/WithdrawalRequests/ViewRequest/ViewRequest";
import Options from "../pages/Admin/Options/Options";

var AdminRoutes = [
  {
    path: "dashboard",
    name: "Dashboard",
    element: <AdminDashboard />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "lottery-bulk-creation",
    name: "New Tickets",
    element: <BulkRegistration />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "listing",
    name: "Lottery Listing",
    element: <LotteryListing />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "remaining",
    name: "Remaining Tickets",
    element: <RemainingTickets />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "lottery-bulk-result",
    name: "Ticket Results",
    element: <BulkResult />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "winners",
    name: "Winners",
    element: <WinnersList />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },  
  {
    path: "withdrawals",
    name: "Withdrawals",
    element: <WithdrawalRequests />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "payments",
    name: "Sales Report",
    element: <Payments />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "ticket-reports",
    name: "Ticket Report",
    element: <TicketReports />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "customers",
    name: "Customers",
    element: <Users />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "inquiries",
    name: "Inquiries",
    element: <Inquiries />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "lottery-brands",
    name: "Lottery Brands",
    element: <LotteryBrands />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "lottery-brand-days",
    name: "Lottery Brand Days",
    element: <LotteryBrandDays />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "banner",
    name: "Banners",
    element: <Banner />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "staff",
    name: "Staff",
    element: <Staff />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "options",
    name: "Options",
    element: <Options />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "listing/:id",
    name: "Loterry Listing",
    element: <ViewTickets />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "profile",
    name: "Profile",
    element: <Profile />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "banner/create-banner",
    name: "Create Banner",
    element: <BannerCreate />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "profile",
    name: "Profile",
    element: <Profile />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "banner/create-banner",
    name: "Create Banner",
    element: <BannerCreate />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "lottery-brand-days/create-lottery-brand-days",
    name: "Create Lottery Brand Days",
    element: <LotteryBrandDaysCreate />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "lottery-brands/create-new-lottery",
    name: "Create New Lottery",
    element: <CreateLotteryBrands />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "lottery-brands/edit-lottery/:id",
    name: "Edit Lottery",
    element: <EditLotteryBrands />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "lottery-brand-days/edit-lottery-days/:id",
    name: "Create Lottery Brand Days",
    element: <EditLotteryBrandDays />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "inquiries/:id",
    name: "Inquiry",
    element: <ViewInquiry />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "listing/MASAM/:id",
    name: "Loterry Listing",
    element: <Masm />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "listing/HADA/:id",
    name: "Loterry Listing",
    element: <Hadahana />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "listing/ADSA/:id",
    name: "Loterry Listing",
    element: <Adsa />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "listing/DHNI/:id",
    name: "Loterry Listing",
    element: <Dhni />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "listing/MEPO/:id",
    name: "Loterry Listing",
    element: <Mepo />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "listing/GOVI/:id",
    name: "Loterry Listing",
    element: <Govi />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "listing/JAYA/:id",
    name: "Loterry Listing",
    element: <Jaya />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },    
  {
    path: "withdrawals/:id",
    name: "Withdrawal Details",
    element: <ViewRequest />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default AdminRoutes;
